import css from 'styled-components';

export const Container = css.div`
    display: flex;
    height: 100vh;
    align-items: center;
    justify-content: center
`;

export const Botao = css.button`
outline: none;
font-size: 18px;
padding: 14px 18px;
cursor: pointer
`;